import { useNavigate } from "react-router-dom";
import { Dashboard } from "@/app/dashboard/Dashboard";
import { useAppContext } from "@/app/providers/AppContext";

/** Keeps routed Watch authoring inside the authenticated portal shell. */
export default function WatchCreatePortalPage() {
  const navigate = useNavigate();
  const { profile, entitlements, api, loading } = useAppContext();

  return (
    <Dashboard
      tabId="watches-create"
      profile={profile}
      entitlements={entitlements}
      loading={loading}
      api={api}
      onUpgrade={() => navigate("/portal/plans")}
      onNewWatch={() => navigate("/portal/watches/new")}
      onTabChange={(tabId) => navigate(`/portal/${tabId}`)}
    />
  );
}
